/**
 * /admin/access-requests - the review queue for the purchase-gated K&C tiers.
 *
 * Thin route: it owns the URL search contract and nothing else. The queue body
 * lives in components/admin/access-requests/AccessRequestsQueue.tsx.
 *
 * It was a Radix tab inside /admin/users, which meant it had no count anybody
 * could see from another page, no address to link, and no survival across a
 * reload. It is a sibling route with a nav badge now (design R6).
 */
import { createFileRoute } from '@tanstack/react-router';
import { AccessRequestsQueue } from '@/components/admin/access-requests/AccessRequestsQueue';
import {
  type AccessRequestsSearch,
  parseAccessRequestsSearch,
} from '@/lib/admin/access-requests';

export const Route = createFileRoute('/admin/access-requests')({
  component: AccessRequestsPage,
  validateSearch: (search: Record<string, unknown>): AccessRequestsSearch =>
    parseAccessRequestsSearch(search),
});

function AccessRequestsPage() {
  return <AccessRequestsQueue />;
}
